/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React from "react";
import classes from "./subscriptionAdjustment.module.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Pagination from "@mui/material/Pagination";
import { Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { withTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { IconButton } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import SubscriptionDialog from "./subscriptionDialog";
import {
  ActivateIcon,
  AutoActivatedIcon,
  ResendEmailIcon,
} from "../../../component/icons/icons";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { formatNumber } from "../../../helper/numberFormatter";

const subscriptionAdjustmentTable = (props) => {
  // const navigate = useNavigate();
  // const [open, setOpen] = useState(false);
  // const [edit, setEdit] = useState(false);

  // const handleClose = () => {
  //     setOpen(false);
  //     setEdit(false);
  // }

  return (
    <div className={classes.root}>
      <TableContainer>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell
                className="global-custom-sorting-header"
                onClick={(e) => {
                  props.updateSorting("subAdjustmentId");
                }}
              >
                <b>{props.t("SUB_ADJUSTMENT_ID")}</b>
                {/* Sort indication */}
                {props.sortBy === "subAdjustmentId" ? (
                  <span className="material-icons">
                    {props.sortOrder === "DESC" ? "expand_less" : "expand_more"}
                  </span>
                ) : (
                  <span className="material-icons sorting-indicator-icon">
                    unfold_more
                  </span>
                )}
              </TableCell>

              <TableCell>
                <b>{props.t("NAME")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("ADJUSTMENT_TYPE")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("ADJUSTMENT_VALUE")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("STATUS")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("CREATED_BY")}</b>
              </TableCell>
              <TableCell>
                <b>{props.t("DATE")}</b>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {/* Show orders list */}
            {props.subscriptionAdjustments.map((row) => (
              <TableRow
                key={row.adjustmentId}
                hover
                className={
                  classes.rowClass + " " + "subscriptionAdjustmentTableRow"
                }
                onClick={(e) => {
                  e.stopPropagation();
                  props.navigate(
                    `/subscriptionAdjustments/${row.adjustmentId}`,
                  );
                }}
              >
                <TableCell component="th" scope="row">
                  {" "}
                  {row.adjustmentId}
                </TableCell>
                <TableCell>{row.name} </TableCell>

                <TableCell>{row.type}</TableCell>
                <TableCell> {row.value ? row.value.amount : null}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.createdBy}</TableCell>
                <TableCell>{row.createdTimestamp}</TableCell>
                {/* <TableCell>
                                        <React.Fragment>
                                            <Tooltip title={props.t('CHANGE_ADJUSTMENT')}>
                                                <IconButton aria-label={props.t('CHANGE_ADJUSTMENT')}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        props.edit(row);
                                                    }}>
                                                    <EditIcon className={classes.tableActionIcons} />
                                                </IconButton>
                                            </Tooltip>
                                        </React.Fragment>
                                    </TableCell> */}
              </TableRow>
            ))}
            {/* If there is no orders to show */}
            {props.showLoading && (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  {props.t("LOADING")}
                </TableCell>
              </TableRow>
            )}
            {!props.showLoading &&
              props.subscriptionAdjustments.length === 0 && (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    {props.t("NO_ADJUSTMENT_FOUND")}
                  </TableCell>
                </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {props.totalOrderCount > 0 && (
        <div
          className="global-custom-pagination"
          style={{ background: "rgba(196, 196, 196, 0.2)" }}
        >
          <label style={{ float: "left", padding: "5px" }}>
            {props.t("TOTAL_RECORDS")}: {formatNumber(props.totalOrderCount)}
          </label>
          <label>
            {/* Rows per page select */}
            {props.t("ROWS_PER_PAGE")}:
            <Select
              value={props.rowsPerPage}
              onChange={props.handleChangeRowsPerPage}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </label>
          {/* Pagination component */}
          <Pagination
            count={Math.ceil(props.totalOrderCount / props.rowsPerPage)}
            onChange={props.handleChangePage}
            page={props.page}
            showFirstButton
            showLastButton
          />
        </div>
      )}
      {/* <SubscriptionDialog
                isOpen={open}
                close={handleClose}
                getSubscriptionAdjustments={this.getSubscriptionAdjustments}
                isEdit={edit}
            /> */}
    </div>
  );
};

export default withTranslation("translations")(subscriptionAdjustmentTable);
